import { cloneDeep } from 'lodash';
import { DATA_EXTRACTION_SET_SESSIONS } from './sessionsActions';
import {
  DATA_EXTRACTION_CLOSE_ALL_MODALS,
  DATA_EXTRACTION_SET_MODAL_PROCESS_DATA,
  DATA_EXTRACTION_SET_MODALS,
  INITIAL_VALUES_LOG_SESSION_FORM
} from './modalActions';

import { DATA_EXTRACTION_FILE_TYPES } from './dataFilesActions';
import { DATA_EXTRACTION_RESET, DATA_EXTRACTION_SET_PROJECT_ID_LISTEN_SOCKET } from './fileImport';
import { SET_PARTICIPANT, SET_SEARCH_MESSAGE } from './participantActions';
import { DATA_EXTRACTION_DATA_TREES,PROJECT_TRANSFORMATIONS } from './dataTreesActions';
import { SET_DIR_LIST, SET_FILE_LIST } from './ftpActions';

const closedModalState = {
  startSession: {
    isOpen: false,
    resourceId: false
  },
  qualitySession: {
    isOpen: false,
    resourceId: false
  },
  logSession: {
    isOpen: false,
    resourceId: false
  },
  messagesSession: {
    isOpen: false,
    resourceId: false
  },
  workerForm: {
    isOpen: false,
    resourceId: false
  },
  confirmProcessData: {
    isOpen: false,
    resourceId: false,
    metricName: false,
    dataQty: false
  },
  downloadModal: {
    isOpen: false,
    resourceId: false
  },
  intialValuesLogSessionForm: {}
};

const initialState = {
  sessions: [],
  modals: cloneDeep(closedModalState),
  fileTypes: [],
  dataTrees: [],
  projectTransformations: [],
  listeningDataTrees: false,
  messages: [],
  intialValuesLogSessionForm: {},
  searchMsg: '',
  participant: { id: null, email: null, age: '-', gender: '-' },
  ftpFileList: [],
  ftpDirList: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATA_EXTRACTION_SET_PROJECT_ID_LISTEN_SOCKET:
      return { ...state, listeningDataTrees: action.listeningDataTrees };

    case DATA_EXTRACTION_SET_SESSIONS:
      return { ...state, sessions: action.sessions };

    case DATA_EXTRACTION_FILE_TYPES:
      return { ...state, fileTypes: action.fileTypes };

    case DATA_EXTRACTION_DATA_TREES:
      return { ...state, dataTrees: action.dataTrees };

    case DATA_EXTRACTION_SET_MODALS:
      return {
        ...state,
        modals: {
          ...state.modals,
          [action.modalType]: {
            ...state.modals[action.modalType],
            isOpen: action.isOpen,
            resourceId: action.resourceId
          }
        }
      };

    case DATA_EXTRACTION_SET_MODAL_PROCESS_DATA:
      return {
        ...state,
        modals: {
          ...state.modals,
          confirmProcessData: {
            isOpen: action.isOpen,
            fileDataId: action.resourceId,
            metricName: action.metricName,
            dataQty: action.dataQty
          }
        }
      };

    case DATA_EXTRACTION_CLOSE_ALL_MODALS:
      return { ...state, modals: cloneDeep(closedModalState) };

    case INITIAL_VALUES_LOG_SESSION_FORM:
      return { ...state, intialValuesLogSessionForm: action.values };

    case DATA_EXTRACTION_RESET:
      return { ...initialState };

    case SET_PARTICIPANT:
      return { ...state, participant: action.participant };

    case SET_SEARCH_MESSAGE:
      return { ...state, searchMsg: action.message };

    case SET_FILE_LIST:
      return {...state, ftpFileList: action.list };

    case SET_DIR_LIST:
      return {...state, ftpDirList: action.list};

    case PROJECT_TRANSFORMATIONS:
      return { ...state, projectTransformations: action.projectTransformations };

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/reducer.js